// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox {
  position: relative;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.checkbox input {
  margin: unset;
  appearance: none;
  position: absolute;
  box-sizing: border-box;
  border-radius: 4px;
  width: 20px;
  height: 20px;
}

.checkbox input:checked + span:before {
  border: unset;
  border: 1px solid red;
  background-color: red;
}

.checkbox input:checked + span:after {
  border-color: #ffffff;
}

.checkbox span {
  pointer-events: none;
}

.checkbox span:before {
  content: '';
  display: inline-block;
  border: 1px solid #999999;
  border-radius: 4px;
  width: 20px;
  height: 20px;
}

.checkbox span:after {
  content: '';
  position: absolute;
  top: 3px;
  left: 3px;
  display: block;
  width: 9px;
  height: 5px;
  border: 2px solid transparent;
  border-top: none;
  border-right: none;
  transform: translate(3px, 4px) rotate(-45deg);
}
`, "",{"version":3,"sources":["webpack://./src/components/Checkbox/style.scss","webpack://./src/components/Checkbox/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;ACCjB;;ADLA;EAMI,aAAa;EAIb,gBAAsB;EACtB,kBAAkB;EAEV,sBAAI;EAWb,kBAAA;ECRD,WAAW;EDhBb,YAKE;ACaF;;AAEA;EDDK,aAAA;ECGH,qBAAqB;EDtBvB,qBAqBa;ACGb;;AAEA;ED1BA,qBA0BO;ACEP;;AAEA;ED9BA,oBA8Bc;ACEd;;AAEA;EDAI,WAAA;EACA,qBAAW;EACX,yBAAY;EACb,kBAAA;ECED,WAAW;EDvCb,YAuCM;ACEN;;AAEA;EDAI,WAAS;EACT,kBAAc;EACd,QAAO;EACP,SAAQ;EACR,cAAQ;EACR,UAAU;EACV,WAAA;EACA,6BAAW;EACZ,gBAAA;ECED,kBAAkB;EAEV,6CAA6C;AACvD","sourcesContent":[".checkbox {\n  position: relative;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  input {\n    margin: unset;\n    appearance: none;\n    position: absolute;\n\n    box-sizing: border-box;\n    border-radius: 4px;\n    width: 20px;\n    height: 20px;\n\n    &:checked + span:before {\n      border: unset;\n      border: 1px solid red;\n      background-color: red;\n    }\n\n    &:checked + span:after {\n      border-color: #ffffff;\n    }\n  }\n\n  span {\n    pointer-events: none;\n  }\n\n  span:before {\n    content: '';\n    display: inline-block;\n    border: 1px solid #999999;\n    border-radius: 4px;\n    width: 20px;\n    height: 20px;\n  }\n\n  span:after {\n    content: '';\n    position: absolute;\n    top: 3px;\n    left: 3px;\n    display: block;\n    width: 9px;\n    height: 5px;\n    border: 2px solid transparent;\n    border-top: none;\n    border-right: none;\n    transform: translate(3px, 4px) rotate(-45deg);\n  }\n}\n",".checkbox {\n  position: relative;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n}\n\n.checkbox input {\n  margin: unset;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  position: absolute;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  width: 20px;\n  height: 20px;\n}\n\n.checkbox input:checked + span:before {\n  border: unset;\n  border: 1px solid red;\n  background-color: red;\n}\n\n.checkbox input:checked + span:after {\n  border-color: #ffffff;\n}\n\n.checkbox span {\n  pointer-events: none;\n}\n\n.checkbox span:before {\n  content: '';\n  display: inline-block;\n  border: 1px solid #999999;\n  border-radius: 4px;\n  width: 20px;\n  height: 20px;\n}\n\n.checkbox span:after {\n  content: '';\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  display: block;\n  width: 9px;\n  height: 5px;\n  border: 2px solid transparent;\n  border-top: none;\n  border-right: none;\n  -webkit-transform: translate(3px, 4px) rotate(-45deg);\n          transform: translate(3px, 4px) rotate(-45deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
